{
  "App": "Aplikasyon",
  "Profile": "Pwofil",
  "My Account": "Kont Mwen",
  "Contacts": "Kontak",
  "Preferences": "Preferans",
  "Family Language": "Lang Familyal",
  "Program Consent": "Konsantman pou Pwogram nan",
  "Yes": "Wi",
  "No": "Non",
  "Not submitted": "Pa t soumèt li",
  "See anything missing? Contact your Caring Adult": "Ou wè gen yon bagay ki manke? Kontakte Granmoun k ap Pran Swen w lan",
  "Messages": "Mesaj",
  "Caring Adult for": "Granmoun k ap Pran Swen pou",
  "Former Caring Adult for": "Granmoun ki te Konn ap Pran Swen pou",
  "Write your message here...": "Ekri mesaj ou a la a...",
  "I need help with": "Mwen bezwen èd avèk",
  "Academic": "Pwogram Akademik",
  "After School/ Out of School": "Pwogram Apre Lekòl/Andeyò Lekòl",
  "Applying for benefits": "Demand avantaj",
  "Childcare": "Gadri",
  "Employment / Adult Education": "Travay/Edikasyon pou Granmoun",
  "Food": "Manje",
  "Housing": "Lojman",
  "Legal services": "Sèvis legal yo",
  "Material Resources / Clothing / Laundry": "Resous Materyèl/Rad/Lesiv",
  "Mental/emotional health": "Sante Mantal/emosyonèl",
  "Physical health/asthma": "Sante fizik/opresyon",
  "Transportation": "Transpò",
  "Send": "Voye ale",
  "Today": "Jodi a",
  "No messages yet": "Poko gen mesaj",
  "No messages": "Pa gen mesaj",
  "Start a conversation below": "Kòmanse yon konvèsasyon anba la a",
  "This Caring Adult is no longer available": "Granmoun k ap Pran Swen sa a pa disponib ankò",
  "No longer available ": "Pa disponib ankò ",
  "Monday": "Lendi",
  "Tuesday": "Madi",
  "Wednesday": "Mèkredi",
  "Thursday": "Jedi",
  "Friday": "Vandredi",
  "Saturday": "Samdi",
  "Sunday": "Dimanch",
  "Emergency Contacts": "Kontak pou Ka Ijans",
  "Supervisor of Social Workers for the Bronx": "Sipèvizè Travayè Sosyal yo pou Bronx",
  "Student Services Manager, High School District": "Jesyonè Sèvis pou Elèv yo, Distri Lekòl Segondè a",
  "Social Worker, Central Crisis Support Team": "Travayè Sosyal, Ekip Santral pou Sipò nan Ka Kriz (Central Crisis Support Team)",
  "Support Line": "Liy Sipò",
  "Suicide and Crisis Lifeline": "Liy Telefòn Dijans nan Ka Suisid ak Kriz (Suicide and Crisis Lifeline)",
  "Emergencies": "Ijans",
  "If you are facing a life-threatening emergency and need help right now, call or text 911": "Si w ap fè fas ak yon ijans ki prezante danje pou lavi w epi w bezwen èd touswit, rele oswa voye yon mesaj bay 911",
  "About New Visions": "Enfòmasyon sou New Visions",
  "Privacy and Terms": "Konfidansyalite ak Kondisyon",
  "Homepage": "Paj Akèy",
  "Home Page": "Paj Akèy",
  "My family": "Fanmi M",
  "Available Services": "Sèvis ki Disponib yo",
  "Grade": "Klas",
  "School": "Lekòl",
  "Attendance this year": "Prezans ane sa a",
  "Absences last 5 days": "Absans pandan 5 dènye jou yo",
  "Caring Adult": "Granmoun k ap Pran Swen",
  "Message": "Mesaj",
  "Not available": "Pa disponib",
  "Not yet assigned": "Poko asiyen",
  "No absences": "Pa gen absans",
  "Phone not available": "Telefòn nan pa disponib",
  "Email address not available": "Adrès imèl la pa disponib",
  "January": "Janvye",
  "February": "Fevriye",
  "March": "Mas",
  "April": "Avril",
  "May": "Me",
  "June": "Jen",
  "July": "Jiyè",
  "August": "Out",
  "September": "Septanm",
  "October": "Oktòb",
  "November": "Novanm",
  "December": "Desanm",
  "Sidenav": "Navigasyon lateral",
  "Home": "Akèy",
  "Log out": "Dekonekte",
  "Accessibility": "Aksesibilite",
  "Skip to main content": "Sote pou ale nan kontni prensipal la",
  "Email": "Imèl",
  "Phone": "Telefòn",
  "Family Portal": "Pòtay Familyal",
  "Every Child and Family is Known": "Nou Konn Tout Timoun ak Fanmi yo",
  "Family Portal: Every Child and Family is Known": "Pòtay Familyal: Nou Konn Tout Timoun ak Fanmi yo",
  "Close menu": "Fèmen meni an",
  "Open menu": "Ouvri meni an",
  "Notes": "Nòt",
  "Send message": "Voye mesaj",
  "Languages": "Lang",
  "Consent status": "Estati konsantman an",
  "Select": "Seleksyone",
  "Language selector": "Seleksyon lang",
  "Sorry": "Dezole",
  "we couldn't find that page": "nou pa t rive jwenn paj sa a",
  "You are not yet authorized to log in to the Family Portal. Please reach out to your Caring Adult for access.": "Ou poko otorize pou w konekte sou Portal Fanmi an. Tanpri kontakte granmoun k ap pran swen w la pou w jwenn aksè."
}